module.exports = __webpack_public_path__ + "static/media/iconCommitWalk.b4e2a7a9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/Icons/iconCommitWalk.svg
// module id = 944
// module chunks = 0